import axios from 'axios'
// import store from '@/store'
import NProgress from 'nprogress'
import { Message } from 'element-ui'
import { Toast } from 'vant'
// const baseURL = process.env.VUE_APP_BASE_URL + '/mock/56'
// const baseURL = process.env.VUE_APP_BASE_URL + '/mock/74'
const baseURL = process.env.VUE_APP_BASE_URL
NProgress.configure({ showSpinner: false })
const request = axios.create({
  baseURL: baseURL,
  timeout: 60000,
  headers: {
    // 'Content-Type': 'application/json',
    // 'Accept': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    let ua = navigator.userAgent.toLowerCase();
    // 在微信浏览器和app环境下隐藏进度条
    if (ua.match(/MicroMessenger/i) != "micromessenger" && ua.indexOf('gkztc') == -1 ) {
      NProgress.start()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截器

request.interceptors.response.use(
  response => {
    NProgress.done()
    if (response.data.code == 0) {
      return response.data
    } else {
      if(response.config.url.indexOf('/v1/default/loginid')>-1){
        // 不需要弹出报错提示
      }else if('10004,10003,10000,26005'.indexOf(response.data.code)>-1) {
      // }else if(response.data.code == 10004 || response.data.code == 10003|| response.data.code == 10000) {
        console.log('不需要弹出报错提示');
      }else{
        // Message.error({
        //   message: response.data.msg
        // })
        Toast(response.data.msg)
      }
      return response.data
    }
  },
  error => {
    if(error.response&&error.response.status == 403){
      // 未登录或登录失效
      localStorage.removeItem('loginInfo')
      localStorage.removeItem('uid')
      // location.reload()
    }else{
      // Message.error({
      //   message: error.response?error.response.data.msg:error.message
      // })
      Toast(error.response?error.response.data.msg:error.message)
    }
    
    NProgress.done()
    return Promise.reject(error)
  }
)
export default request
